import { subscribeExt } from "../modules/subscribe";

export function eventsPage() {

    function fix_size($img_container) {
        var img_cl = $img_container+' img';
        var images = $(img_cl);

        images.each(setsize);

        function setsize() {
            var img = $(this),
                img_dom = img.get(0),
                container = img.parents($img_container);
            if (img_dom.complete) {
                resize();
            } else{
                img.one('load', resize);
            }

            function resize() {

                if ((container.width() / container.height()) < (img_dom.width / img_dom.height)) {
                    img.width('110%');
                    img.height('auto');
                } else {
                    img.height('110%');
                    img.width('auto');
                }
            }
        }
    }


    function filtersDesc(){
        if($('.filter-section').length > 0) {

            var get_date_range = '';
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');

                if(pair[0] == 'date_range'){
                    if(pair[1].indexOf('%20-%20') + 1){
                        get_date_range = pair[1].split('%20-%20');
                    } else if(pair[1].indexOf('+-+') + 1) {
                        get_date_range = pair[1].split('+-+');
                    }
                }
            }

            console.log(get_date_range);

            var $select         = $('.events_categories').selectize();

            $(document).on('click', 'div.events_categories .item', function () {
                var $item_id        = $(this).attr("data-value");
                var selectize       = $select[0].selectize;
                selectize.removeItem($item_id);
                selectize.refreshItems();
                selectize.refreshOptions();
            });

            var date        = new Date();
            var format_date = moment(date).format('DD-MM-Y');

            $('.events-filter-widget input[name="date_range"]').daterangepicker({
                opens: 'left',
                startDate: get_date_range[0],
                endDate: get_date_range[1],
                minYear: date.getFullYear(),
                minDate: format_date,
                locale: revent_data.pll_filter_date,
            });

            $('.events-filter-widget input[name="date_range"]').on('apply.daterangepicker', function(ev, picker){
                var changeDate = picker.element[0].value;
                var splitDates = changeDate.split(' - ');
                moment.updateLocale('en', {months : revent_data.pll_filter_date.monthNames});
                var startDate = moment(splitDates[0], 'DD-MM-YYYY').format('DD MMMM');
                var endDate = moment(splitDates[1], 'DD-MM-YYYY').format('DD MMMM');
                $('#visible_date_range_start').val(startDate);
                $('#visible_date_range_end').val(endDate);
            });

            $('#visible_date_range_start, #visible_date_range_end').on('focus', function (e) {
                $('.events-filter-widget input[name="date_range"]').triggerHandler('click');
            });
        }
    }

    function filtersMob() {

        jQuery(document).ready(function ($) {

            if($('.mobile-filters').length > 0) {

                var get_date_range = '';
                var query = window.location.search.substring(1);
                var vars = query.split('&');
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split('=');

                    if(pair[0] == 'date_range'){
                        if(pair[1].indexOf('%20-%20') + 1){
                            get_date_range = pair[1].split('%20-%20');
                        } else if(pair[1].indexOf('+-+') + 1) {
                            get_date_range = pair[1].split('+-+');
                        }
                    }
                }

                $('.mob-open-filters').on('click', function () {
                    $('body').toggleClass('scroll_disabled');
                    $(this).next('.mobile-filters').toggleClass('f-visible');
                });

                $('.btn-close').on('click', function () {
                    $('body').toggleClass('scroll_disabled');
                    $(this).parent('.mobile-filters').toggleClass('f-visible');
                });

                var date        = new Date();
                var format_date = moment(date).format('DD-MM-Y');
                var target_id   = '';

                $('.mobile-filters input[name="date_range"]').daterangepicker({
                    opens: 'right',
                    drops: 'up',
                    startDate: get_date_range[0],
                    endDate: get_date_range[1],
                    minYear: date.getFullYear(),
                    minDate: format_date,
                    locale: revent_data.pll_filter_date,
                    autoApply: true
                });

                $('.mobile-filters input[name="date_range"]').on('apply.daterangepicker', function(ev, picker){
                    var changeDate = picker.element[0].value;
                    var splitDates = changeDate.split(' - ');
                    moment.updateLocale('en', {months : revent_data.pll_filter_date.monthNames});
                    var startDate = moment(splitDates[0], 'DD-MM-YYYY').format('DD MMMM');
                    var endDate = moment(splitDates[1], 'DD-MM-YYYY').format('DD MMMM');
                    $('#visible_mob_date_range_start').val(startDate);
                    $('#visible_mob_date_range_end').val(endDate);
                });

                $('#visible_mob_date_range_start, #visible_mob_date_range_end').on('focus', function (e) {
                    target_id = e.target;
                    $('.mobile-filters input[name="date_range"]').triggerHandler('click');
                });
            }
        });
    }

    function ajax_jobs_output(page, find, query)
    {
        var $parent_wrp = $('#load_more_events').parents('.pagination-wrp').parent();
        var $date_range = $('#load_more_events').attr('data-date-range');

        $.ajax({
            url: revent_data.ajax_url,
            type:'POST',
            data: {
                action: 'al_load_events',
                page:   page,
                range:  $date_range,
                find:   find,
                query:   query,
            },
            beforeSend: function(){
                $('.load-more-events a, .load-more-events span').hide();
                $('.before-send-events').show();
            },
            success:function(data){
                $('.before-send-events').hide();
                $('.load-more-events a, .load-more-events span').show();
                var text = data.from + ' - ' +data.to;
                $('#load_more_events').attr('data-events-page', data.next_page);
                $parent_wrp.find('.from-to').text(text);
                $parent_wrp.before(data.events);

                if(data.max_num_pages < data.next_page){
                    $('#load_more_events').hide();
                }
            }
        });
    }



    function showViewport()
    {
        var selector    = document.querySelector('.events');
        var height      = Math.max(selector.clientHeight, window.innerHeight || 0) + 200;
        $('.side-overlay').css({'height': height+'px'});

        var $window = $(window);
        var $sidebar = $("#events-sidebar");
        var $sidebarHeight = $sidebar.innerHeight();
        var $sibling_block_height = $('.events');

        if($sidebarHeight < $sibling_block_height.innerHeight() - 200) {

            var $footerOffsetTop = $(".table-calendar").offset().top - 200;
            var $sidebarOffset = $sidebar.offset();

            $window.scroll(function () {

                if ($window.scrollTop() > $sidebarOffset.top) {
                    $sidebar.addClass("fixed").addClass("sticky");
                } else {
                    $sidebar.removeClass("sticky");
                    $sidebar.removeClass("fixed");
                }

                if ($window.scrollTop() + $sidebarHeight > $footerOffsetTop - 70) {
                    $sidebar.removeClass("sticky");
                    $sidebar.css({"top": -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
                } else {
                    $sidebar.css({"top": "0"});
                }
            });
        }
        //return [width, height]
    }

    function actions() {

        if($('body').hasClass('events-archive')){
            subscribeExt(500);
        }

        if($('.events-container').length > 0) {

            window.onload = showViewport;
            window.onresize = showViewport;

            if($('#load_more_events').length > 0){
                $('#load_more_events').on('click', function (e){
                    e.preventDefault();
                    var events_page = $('#load_more_events').attr('data-events-page');
                    var events_find = $('#load_more_events').attr('data-events-find');

                    ajax_jobs_output(events_page, events_find, data_query_obj2);
                });
            }

            fix_size('.event-item a');
            filtersDesc();
            filtersMob();

        }
    }

    actions();
}




// WEBPACK FOOTER //
// ./assets/js/pages/events.js